import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import NoAuth from '@/views/components/noAuth/noAuth.vue';

@Component({
  components: {
    NoAuth,
  },
})
export default class blackList extends Vue {
  public BlackConfig: ItemObject = {
    desc: {}, // 活动中签黑名单
  };

  /**
   * 获取黑名单
   * @return null
   */
  public getBlackList(): void {
    const queryParams = {
      siteId: Number.parseInt(this.$route.params.siteId),
      moduleType: 2,
    };
    IPSService.siteInfo({ queryParams })
      .then((res) => {
        if (res && res.list) {
          res.list.forEach((item) => {
            if (item.filedType !== 'ActWinHide') {
              return;
            }
            this.BlackConfig = item;
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /**
   * 格式化字符串
   * @param {string} str
   * @return {string}
   */
  public trim(str: string): string {
    str = str.replace(/，/gi, ','); // 去除中文逗号
    str = str.replace(/[\n\r]/g, ''); // 去除换行
    const strList = []; // 去除两端空格
    str.split(',').forEach((item) => {
      if (item) { strList.push(item.replace(/(^\s*)|(\s*$)/g, '')); }
    });
    return strList.join();
  }

  dealStr() {
    this.BlackConfig.desc.mobiles = this.BlackConfig.desc.mobiles.replace(/[\n\r ()+.|。，]/g, ',');
    this.BlackConfig.desc.mobiles = this.BlackConfig.desc.mobiles.replaceAll(',,', ',');
  }

  public onSubmitBlackListData(): void {
    // 组装参数
    const postParams = {
      siteId: this.$route.params.siteId,
      list: [this.BlackConfig],
      moduleType: 2,
    };
    IPSService.saveSiteEdit({ postParams }).then((res) => {
      if (res) { this.$message.success('保存成功'); }
    });
  }

  public created() {
    this.getBlackList();
  }
}
